import { useI18nContext } from '@/i18n/i18n-react';

export function TreeDndNotLabel() {
  const { LL } = useI18nContext();

  return (
    <span className="rounded-sm bg-destructive/15 px-1.5 py-0.5 text-xs font-semibold uppercase tracking-wider text-destructive">
      {LL.audiences.details.overview.filterConditions.operators.not()}
    </span>
  );
}
